const PLACEHOLDER = /\{([a-zA-Z0-9_]+)\}/g;

export function destinationBasePath() {
  const web = window.blclient?.data?.links?.web;
  if (typeof web !== "string" || web === "") {
    return "";
  }
  try {
    return new URL(web).pathname.replace(/\/$/, "");
  } catch {
    return "";
  }
}

export function resolveLinkUrl(template, readField) {
  if (!template) {
    return "";
  }
  let unresolved = false;
  const url = template.replace(PLACEHOLDER, (match, fieldName) => {
    const value = readField(fieldName);
    if (value === undefined || value === null || value === "") {
      unresolved = true;
      return match;
    }
    return String(value);
  });
  if (unresolved) {
    return "";
  }
  return url.startsWith("/") ? destinationBasePath() + url : url;
}
